import wixEcomFrontend from "wix-ecom-frontend";
import { to } from 'wix-location-frontend';

$w("#cartIcon").onClick(() => {
    // on button click - open the side cart
    wixEcomFrontend.openSideCart();
});

$w('#accountIcon').onClick((event) => {
    to('/profile');
})